<template>
  <div class="table_box">
    <div class="table-data">
      <div class="tb-head">
        <div class="tb-th user-col cell">权限设置</div>
        <div class="tb-th menu-col cell">菜单功能</div>
        <div class="tb-th auth-col cell">菜单显示</div>
        <div class="tb-th auth-col cell">数据查看</div>
        <div class="tb-th auth-col cell">修改</div>
        <div class="tb-th auth-col cell">删除</div>
      </div>
      <div class="tb-body">
        <ul class="user-list user-col">
          <ul class="sub-menu">
            <li v-for="user in userList" :key="user.id">
              <span
                :class="{ active: currentUser === user.id }"
                @click="changeUser(user.id)"
                >{{ user.nickname }}</span
              >
            </li>
          </ul>
        </ul>
        <div class="menu-list">
          <table cellspacing="0">
            <tbody>
              <template
                v-for="(mainMenu, mainIndex) in menuList"
                :key="mainMenu.parentName"
              >
                <tr class="menu-item">
                  <td class="menu-col">
                    {{ mainMenu.parentContent }}
                  </td>
                  <td class="auth-col"></td>
                  <td class="auth-col"></td>
                  <td class="auth-col"></td>
                  <td class="auth-col"></td>
                </tr>
                <template
                  v-for="(subMenu, subIndex) in mainMenu.children"
                  :key="subMenu.childrenId"
                >
                  <tr class="menu-col">
                    <td class="menu-col">{{ subMenu.childrenContent }}</td>
                    <!-- 菜单显示权限（menu） -->
                    <td class="auth-col">
                      <el-checkbox
                        v-model="
                          subMenu.permission.find((p) => p.permType === 'menu')
                            .delflag
                        "
                        @change="
                          (flag) =>
                            handleAuthChange(mainIndex, subIndex, 'menu', flag)
                        "
                      />
                    </td>
                    <!-- 数据查看权限（select） -->
                    <td class="auth-col">
                      <el-checkbox
                        v-model="
                          subMenu.permission.find(
                            (p) => p.permType === 'select'
                          ).delflag
                        "
                        @change="
                          (flag) =>
                            handleAuthChange(
                              mainIndex,
                              subIndex,
                              'select',
                              flag
                            )
                        "
                      />
                    </td>
                    <!-- 修改权限（update） -->
                    <td class="auth-col">
                      <el-checkbox
                        v-model="
                          subMenu.permission.find(
                            (p) => p.permType === 'update'
                          ).delflag
                        "
                        @change="
                          (flag) =>
                            handleAuthChange(
                              mainIndex,
                              subIndex,
                              'update',
                              flag
                            )
                        "
                      />
                    </td>
                    <!-- 删除权限（delete） -->
                    <td class="auth-col">
                      <el-checkbox
                        v-model="
                          subMenu.permission.find(
                            (p) => p.permType === 'delete'
                          ).delflag
                        "
                        @change="
                          (flag) =>
                            handleAuthChange(
                              mainIndex,
                              subIndex,
                              'delete',
                              flag
                            )
                        "
                      />
                    </td>
                  </tr>
                </template>
              </template>
              <tr
                v-if="
                  !menuList.length || menuList.every((m) => !m.children.length)
                "
              >
                <td colspan="6" class="empty-tip">暂无权限数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
const props = defineProps({
  userList: Array,
  menuList: Array,
  currentUser: Number,
});

const emit = defineEmits(["changeUser", "changeAuth"]);

const changeUser = (id) => {
  if (props.currentUser === id) return false;
  emit("changeUser", id);
};

const handleAuthChange = (mainIndex, subIndex, permType, flag) => {
  emit("changeAuth", {
    mainIndex,
    subIndex,
    permType,
    flag,
  });
};
</script>

<style lang="scss" scoped>
@import "./TableData";
</style>
